import { fetchWithRetry } from '@tunein/web-utils';
import forEach from 'lodash/forEach';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import isString from 'lodash/isString';
import join from 'lodash/join';
import truncate from 'lodash/truncate';
import adsSettings from '../../js/utils/adsSettings';
import { State, getState } from '../../js/utils/applicationState';
import { getBreakpointName } from '../../js/utils/breakpointUtils';
import { MediumTypes, Networks, PlayStates } from '../../js/utils/constants';
const MAX_ERROR_LENGTH = 1000;
const REQUEST_ENDPOINT = 'r';
const getGuideIdParameter = (slot) => {
    if (!slot) {
        return null;
    }
    let isPassingGuideId = true;
    if (slot.formatDefinition &&
        slot.formatDefinition.adProvider === Networks.dfp &&
        getState(State.playerStatus) !== PlayStates.playing &&
        getState(State.playerStatus) !== PlayStates.connecting) {
        isPassingGuideId = false;
    }
    let ret = null;
    if (isPassingGuideId) {
        const guideIds = adsSettings.getNowPlayingGuideIds();
        if (!isEmpty(guideIds)) {
            ret = join(guideIds, ',');
        }
    }
    return ret;
};
const reporter = {
    request(slot) {
        const params = this.getParameters(slot, REQUEST_ENDPOINT);
        this.postReport(REQUEST_ENDPOINT, params);
    },
    impression(slot) {
        const params = this.getParameters(slot);
        params.t = -1;
        this.postReport('i', params);
    },
    view(slot) {
        const params = this.getParameters(slot);
        this.postReport('v', params);
    },
    click(slot) {
        const params = this.getParameters(slot);
        this.postReport('c', params);
    },
    fail(slot, message) {
        if (!(get(slot, 'formatDefinition.reportError') && message)) {
            return;
        }
        const params = this.getParameters(slot);
        const messageString = isString(message) ? message : JSON.stringify(message);
        params.m = truncate(messageString, { length: MAX_ERROR_LENGTH });
        params.t = -1;
        this.postReport('f', params);
    },
    start(slot) {
        const params = this.getParameters(slot);
        this.postReport('start', params);
    },
    credit(slot) {
        const params = this.getParameters(slot);
        this.postReport('unlockcredit', params);
    },
    xButton(slot) {
        const params = this.getParameters(slot);
        this.postReport('xbutton', params);
    },
    skip(slot) {
        const params = this.getParameters(slot);
        this.postReport('skip', params);
    },
    end(slot) {
        const params = this.getParameters(slot);
        this.postReport('end', params);
    },
    async postReport(endpoint, params) {
        const api = getState(State.api);
        const { f: adFormat } = params || {};
        const url = new URL(`${api.domains.reports}/reports/a/${endpoint}`);
        url.search = new URLSearchParams(params);
        await fetchWithRetry(url, {
            credentials: 'include',
            method: 'POST',
            parseAs: null,
        });
    },
    getParamsForSlotList(slotList) {
        const params = [];
        forEach(slotList, (slot) => params.push(this.getParameters(slot)));
        return params;
    },
    getParameters(slot, endpoint) {
        let dimensions;
        switch (slot.medium) {
            case MediumTypes.display: {
                if (endpoint === REQUEST_ENDPOINT) {
                    if (slot.formatDefinition?.dimensions) {
                        const flatDimensions = slot.formatDefinition.dimensions.map((dimensionsArray) => dimensionsArray.join('x'));
                        dimensions = flatDimensions.join(',');
                    }
                }
                else {
                    dimensions = join(slot.currentDimensions, 'x');
                }
                break;
            }
            case MediumTypes.video: {
                dimensions = MediumTypes.video;
                break;
            }
            case MediumTypes.audio: {
                dimensions = MediumTypes.audio;
                break;
            }
            default:
        }
        const { adUnitId, appendPartnerAliasToAdUnitId, adProvider } = slot.formatDefinition || {};
        const partnerAlias = get(getState(State.config), 'targeting.ads_partner_alias');
        const params = {
            r: slot.requestId,
            n: adProvider,
            f: dimensions || 'unknown',
            l: slot.name,
            u: appendPartnerAliasToAdUnitId ? `${adUnitId}${partnerAlias}` : adUnitId,
            resolution: `${get(global, 'window.innerWidth', '')},${get(global, 'window.innerHeight', '')}`,
            serial: getState(State.rtid),
            partnerId: getState(State.partnerId),
            version: getState(State.version) || '2.0',
        };
        const currentScreen = getState(State.currentScreen);
        params.s = join([currentScreen, getBreakpointName()], '-');
        const i = getGuideIdParameter(slot);
        if (i) {
            params.i = i;
        }
        const unlockDetails = getState(State.unlockDetails);
        if (unlockDetails?.CampaignId && adsSettings.isUnlocked()) {
            params.uc = unlockDetails.CampaignId;
        }
        if (slot.campaignId) {
            params.c = slot.campaignId;
        }
        const userName = getState(State.userName);
        if (userName) {
            params.username = userName;
        }
        const desktopVersion = getState(State.desktopVersion);
        if (desktopVersion) {
            params.desktopVersion = desktopVersion;
        }
        return params;
    },
};
export default reporter;
